import React from 'react'
import { Link } from 'react-router-dom'
import { FaFacebook, FaInstagram, FaYoutube, FaLocationArrow } from "react-icons/fa";

function Footer() {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Optional: Adds smooth scrolling
        });
    };
    return (
        <>
            {/* Footer Start */}
            <div className="container-fluid footer bg-white text-black py-4 px-4 px-lg-5 wow fadeIn" data-wow-delay="0.1s">

                {/* MAIN FOOTER ROW – CENTERED ITEMS LIKE YOUR SAMPLE */}
                <div className="row justify-content-center text-center">

                    <div className="col-12 mb-3">
                        <h1 className="display-5 text-black">Visora Visuals</h1>
                    </div>

                    <div className="col-12 d-flex flex-wrap justify-content-center align-items-center gap-4">

                        <p className="mb-0 d-flex align-items-center">
                            <i className="fa fa-map-marker-alt me-2" />
                            G-408, Sumel 11, Indian textile plaza, Namaste Circle, Shahibaug, Ahmedabad, Gujarat 380004
                        </p>

                        <p className="mb-0 d-flex align-items-center">
                            <i className="fa fa-phone-alt me-2" />
                            092747 90059
                        </p>

                        <p className="mb-0 d-flex align-items-center">
                            <i className="fa fa-envelope me-2" />
                            visoravisuals@gmail.com
                        </p>

                    </div>

                    {/* SOCIAL ICONS */}
                    <div className="col-12 mt-4 d-flex justify-content-center gap-3">

                        <a href="https://www.instagram.com/visoravisuals?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer"
                            className="btn btn-square btn-outline-primary rounded-circle">
                            <FaInstagram />
                        </a>

                        <a href="https://www.facebook.com/profile.php?id=61554651937748" target="_blank" rel="noopener noreferrer"
                            className="btn btn-square btn-outline-primary rounded-circle">
                            <FaFacebook />
                        </a>

                        <a href="https://maps.app.goo.gl/uyTaWnkK9DGPLaqz6" target="_blank" rel="noopener noreferrer"
                            className="btn btn-square btn-outline-primary rounded-circle">
                            <FaLocationArrow />
                        </a>

                    </div>
                </div>

                {/* Footer bottom copyright */}
                <div className="mt-3 pt-2 border-top border-secondary">
                    <p className="text-sm text-black text-center mb-0">
                        © {new Date().getFullYear()},{" "}
                        <Link to="/" className="text-black fw-bold">
                            Visora Visuals
                        </Link>{" "}
                        | Developed by{" "}
                        <a
                            href="https://www.ajtechsolution.com" // <-- change to your real link
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-black fw-bold"
                        >
                            AJ Tech Solution
                        </a>
                    </p>
                </div>
            </div>
            {/* Footer End */}
        </>
    )
}

export default Footer
